import videojs from 'video.js/dist/video'
import extend from 'extend'
import './cd-poster.less'

const VjsPosterImage = videojs.getComponent('PosterImage');

const defaultOptions = {
    cd: {
        rotate: true
    }
};

/**
 * CD Poster UI Component class
 */
class CDPoster extends VjsPosterImage {

    constructor(player, options) {
        super(player, extend(defaultOptions, options));
    }

    createEl() {
        const el = videojs.dom.createEl('div', {
            className: 'vjs-cd-poster',
            // Don't want poster to be tabbable.
            tabIndex: -1
        });
        el.appendChild(videojs.dom.createEl('div', {
            className: 'vjs-cd-poster'
        }))

        if (this.options_.cd.rotate) {
            el.className += ' vjs-cd-rotate';
        }
        return el;
    }
    setSrc(url) {
        let backgroundImage = '';

        if (url) {
            backgroundImage = `url("${url}")`;
        }

        this.el().children[0].style.backgroundImage = backgroundImage;
    }
    rotate(enable) {
        if (enable) {
            this.addClass('vjs-cd-rotate');
        } else {
            this.removeClass('vjs-cd-rotate');
        }
    }
}

videojs.registerComponent("CDPoster", CDPoster);

export default CDPoster;